/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptimizeTransportLotRequestTodayStockListInner
 */
export interface OptimizeTransportLotRequestTodayStockListInner {
    /**
     * 入荷日
     * @type {Date}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    recDate: Date;
    /**
     * 商品コード
     * @type {string}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    itemCode: string;
    /**
     * 最大パレット積載数
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    maxPalletQuantity: number;
    /**
     * 重量（kg）
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    weight: number;
    /**
     * ケースロット数
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    caseLot: number;
    /**
     * 入荷予定数
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    arrivalQuantityPlan: number;
    /**
     * 在庫数
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    stockQuantity: number;
    /**
     * 平均出荷予測数
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    avgShipExpected: number;
    /**
     * 
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    stockDays: number | null;
    /**
     * 入荷停止フラグ
     * @type {boolean}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    stopArrival: boolean;
    /**
     * 在庫日数設定
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    stockDaysSetting: number;
    /**
     * 出荷停止
     * @type {boolean}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    stopShip: boolean;
    /**
     * 発注推奨数から変更を行っていない
     * @type {boolean}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    isUpdatedArrival: boolean;
    /**
     * 
     * @type {number}
     * @memberof OptimizeTransportLotRequestTodayStockListInner
     */
    orderQuantityRec: number | null;
}

/**
 * Check if a given object implements the OptimizeTransportLotRequestTodayStockListInner interface.
 */
export function instanceOfOptimizeTransportLotRequestTodayStockListInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recDate" in value;
    isInstance = isInstance && "itemCode" in value;
    isInstance = isInstance && "maxPalletQuantity" in value;
    isInstance = isInstance && "weight" in value;
    isInstance = isInstance && "caseLot" in value;
    isInstance = isInstance && "arrivalQuantityPlan" in value;
    isInstance = isInstance && "stockQuantity" in value;
    isInstance = isInstance && "avgShipExpected" in value;
    isInstance = isInstance && "stockDays" in value;
    isInstance = isInstance && "stopArrival" in value;
    isInstance = isInstance && "stockDaysSetting" in value;
    isInstance = isInstance && "stopShip" in value;
    isInstance = isInstance && "isUpdatedArrival" in value;
    isInstance = isInstance && "orderQuantityRec" in value;

    return isInstance;
}

export function OptimizeTransportLotRequestTodayStockListInnerFromJSON(json: any): OptimizeTransportLotRequestTodayStockListInner {
    return OptimizeTransportLotRequestTodayStockListInnerFromJSONTyped(json, false);
}

export function OptimizeTransportLotRequestTodayStockListInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizeTransportLotRequestTodayStockListInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recDate': (new Date(json['rec_date'])),
        'itemCode': json['item_code'],
        'maxPalletQuantity': json['max_pallet_quantity'],
        'weight': json['weight'],
        'caseLot': json['case_lot'],
        'arrivalQuantityPlan': json['arrival_quantity_plan'],
        'stockQuantity': json['stock_quantity'],
        'avgShipExpected': json['avg_ship_expected'],
        'stockDays': json['stock_days'],
        'stopArrival': json['stop_arrival'],
        'stockDaysSetting': json['stock_days_setting'],
        'stopShip': json['stop_ship'],
        'isUpdatedArrival': json['is_updated_arrival'],
        'orderQuantityRec': json['order_quantity_rec'],
    };
}

export function OptimizeTransportLotRequestTodayStockListInnerToJSON(value?: OptimizeTransportLotRequestTodayStockListInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rec_date': (value.recDate.toISOString().substring(0,10)),
        'item_code': value.itemCode,
        'max_pallet_quantity': value.maxPalletQuantity,
        'weight': value.weight,
        'case_lot': value.caseLot,
        'arrival_quantity_plan': value.arrivalQuantityPlan,
        'stock_quantity': value.stockQuantity,
        'avg_ship_expected': value.avgShipExpected,
        'stock_days': value.stockDays,
        'stop_arrival': value.stopArrival,
        'stock_days_setting': value.stockDaysSetting,
        'stop_ship': value.stopShip,
        'is_updated_arrival': value.isUpdatedArrival,
        'order_quantity_rec': value.orderQuantityRec,
    };
}

